export default __webpack_public_path__ + "static/media/p2023-26.4fbf90e7.jpeg";